const ArrowBackIcon = () => {
	return (
		<svg 
            className="backarrow"
            width="24" 
            height="24" 
            viewBox="0 0 24 24" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M12 24L0 12L12 0L13.575 1.575L4.275 10.875H24V13.125H4.275L13.575 22.425L12 24Z" fill="#64648C"/>
        </svg>
	);
};

export default ArrowBackIcon;
